<template>
  <div>
    <global-details-popup :vModel="cancelModal">
        <v-container style="background-color: #ffffff !important">
          <global-cancel-popup
            :iconText="'Are you sure you would like to cancel the certificate request submission?'"
            :breadText="'All data entered will be lost upon cancellation'"
          >
            <template v-slot:closeCancel>
                <v-btn icon>
                    <v-icon medium @click="cancelCancel">
                      fa-light fa-xmark
                    </v-icon>
                </v-btn>
            </template>
            <template v-slot:cancelActions>
                <v-btn plain color="blue accent-4" @click="cancelCancel">
                  No
                </v-btn>
                <v-btn
                  dark
                  color="teal darken-2"
                  elevation="0"
                  @click="$router.push({name: 'Certificates'})"
                >Yes</v-btn>
            </template>
          </global-cancel-popup>
        </v-container>
    </global-details-popup>
    <!-- NOT WORKING  -->
    <!-- <v-snackbar
      v-model="showSucessModal"
      top
      right
      color="#DBEBD2"
    >
      <global-msg-alert
        iconColor="#487A7B"
        iconSize="2.5rem"
        icon="mdi-check-circle"
        textColor="color: #487A7B"
        type="Success"
        timeout="1000"
        :msg="successMsg"
      ></global-msg-alert>
    </v-snackbar>
    <v-snackbar v-model="showErrorModal" top right color="#FCE1D8">
      <global-msg-alert
        iconColor="#9D0E1C"
        iconSize="2.5rem"
        icon="fa-solid fa-circle-exclamation"
        textColor="color: #9D0E1C"
        timeout="1000"
        type="Error"
        :msg="errorMsg"
      ></global-msg-alert>
    </v-snackbar>
    <v-snackbar
      v-model="uploadErrorModal"
      top
      right
      color="#FCE1D8"
    >
      <global-msg-alert
        iconColor="#9D0E1C"
        iconSize="2.5rem"
        icon="fa-solid fa-circle-exclamation"
        textColor="color: #9D0E1C"
        timeout="1000"
        type="Error"
        msg="Please upload a CSR"
      ></global-msg-alert>
    </v-snackbar> -->
    <!-- NOT WORKING  -->
  </div>
</template>
<script>
import GlobalMsgAlert from "@/components/global/global-msg-alert.vue";
import GlobalDetailsPopup from "@/components/global/global-details-popup.vue"
import GlobalCancelPopup from "@/components/global/global-cancel-popup.vue"

export default {
    props:["cancelSubmit","showSuccess", "successMsg", "showError", "errorMsg", "uploadError", "doneUpload"],
    components:{
        GlobalMsgAlert,
        GlobalDetailsPopup,
        GlobalCancelPopup,
    },
    computed:{
        cancelModal:{
            get:function(){
                return this.cancelSubmit;
            },
            set:function(newVal){
                this.$emit("update:cancelSubmit", newVal)
            },
        },
        // showSucessModal:{
        //     get:function(){
        //         return this.showSuccess
        //     },
        //     set:function(newVal){
        //         this.$emit("update:showSuccess", newVal)
        //     }
        // },
        // showErrorModal:{
        //     get:function(){
        //         return this.showError
        //     },
        //     set:function(newVal){
        //         this.$emit("update:showError", newVal)
        //     }
        // },
        // uploadErrorModal:{
        //     get:function(){
        //         return this.uploadError
        //     },
        //     set:function(newVal){
        //         this.$emit("update:uploadError", newVal)
        //     }
        // },
    },
    methods:{
      cancelCancel(){
        this.$emit("cancelSubmitCSR")
      }
    }
}
</script>
<style></style>
